module.exports = __webpack_public_path__ + "img/data.f9f236c8.png";